module.exports = __webpack_public_path__ + "Roboto-LightItalic.cdd1c486770034a6122e.eot";


//////////////////
// WEBPACK FOOTER
// /jenkins/jenkins/workspace/apppronosticos_install_s3_dev/~/roboto-fontface/fonts/Roboto/Roboto-LightItalic.eot
// module id = ../../../../roboto-fontface/fonts/Roboto/Roboto-LightItalic.eot
// module chunks = 5